// **🔄 Apply Zoom & Preserve Scroll**
const applyZoom = (zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize) => {
    const rfpPages = document.querySelectorAll('.rfp-page');
    const container = document.querySelector('.rfp-container');

    if (!rfpPages.length || !container) return;

    const zoomLevel = zoomLevels[zoomIndexRef.current];

    // Preserve scroll position **before** changing zoom
    scrollPositionRef.current = {
        left: container.scrollLeft / container.scrollWidth,
        top: container.scrollTop / container.scrollHeight,
    };

    // Calculate new dimensions
    const newWidth = Math.round(BASE_WIDTH * zoomLevel / 16) * 16;
    const newHeight = Math.round(BASE_HEIGHT * zoomLevel / 16) * 16;
    const newBaseHeight = Math.round((BASE_HEIGHT - 10 * 16) * zoomLevel); // Scale pagination height

    // **Batch State Updates to Prevent Flickering**
    setDocWidth(newWidth);
    setDocHeight(newHeight);
    setBaseHeight(newBaseHeight);
    setFontSize(Math.round(16 * zoomLevel));

    // **Restore scroll position after DOM updates**
    setTimeout(() => {
        container.scrollLeft = scrollPositionRef.current.left * container.scrollWidth;
        container.scrollTop = scrollPositionRef.current.top * container.scrollHeight;
    }, 0);
};

// **🔥 Zoom In/Out Function**
const zoom = (direction, zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize) => {
    let newIndex = zoomIndexRef.current + direction;
    if (newIndex < 0 || newIndex >= zoomLevels.length) return;

    zoomIndexRef.current = newIndex; // Update zoom index
    applyZoom(zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize); // Apply zoom immediately
};

// **🔍 Zoom Controls**
export const zoomIn = (zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize) => zoom(1, zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize);
export const zoomOut = (zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize) => zoom(-1, zoomLevels, zoomIndexRef, scrollPositionRef, BASE_WIDTH, BASE_HEIGHT, setDocWidth, setDocHeight, setBaseHeight, setFontSize);